import PostgreSQLLogo from "assets/migrationGenW/postgresql.svg";
import AmazonSESLogo from "assets/migrationGenW/aws-ses.svg"
import MySQLLogo from "assets/migrationGenW/mysql.svg";
import AnthropicLogo from "assets/migrationGenW/anthropic.svg";
import AppsmithAILogo from "assets/migrationGenW/appsmith-ai.svg";
import ArangoDBLogo from "assets/migrationGenW/arangodb.svg";
import AWSDynamoDBLogo from "assets/migrationGenW/aws-dynamodb.svg";
import AWSLambdaLogo from "assets/migrationGenW/aws-lambda-logo.svg";
import AWSRedshiftLogo from "assets/migrationGenW/aws-redshift.svg";
import AWSS3Logo from "assets/migrationGenW/aws-s3.svg";
import DatabricksLogo from "assets/migrationGenW/databricks-logo-1.svg";
import ElasticLogo from "assets/migrationGenW/elastic.svg";
import FirestoreLogo from "assets/migrationGenW/firestore.svg";
import GoogleAILogo from "assets/migrationGenW/google-ai.svg";
import GooglesheetsLogo from "assets/migrationGenW/GoogleSheets.svg";
import MongoDBLogo from "assets/migrationGenW/mongodb.svg";
import MSSQLLogo from "assets/migrationGenW/mssql.svg";
import OpenAILogo from "assets/migrationGenW/open-ai.svg";
import OracleLogo from "assets/migrationGenW/oracle.svg";
import RedisLogo from "assets/migrationGenW/redis.svg";
import SMTPLogo from "assets/migrationGenW/smtp-icon.svg";
import SnowflakeLogo from "assets/migrationGenW/snowflake.svg";
import AirtableLogo from "assets/migrationGenW/airtable.svg";
import GraphQLLogo from "assets/migrationGenW/graphql.svg";
import RestAPILogo from "assets/migrationGenW/RestAPI.png";
import HubSpotLogo from "assets/migrationGenW/hubspot.png";
import TwilioLogo from "assets/migrationGenW/twilio.png";
import JSFunctionsLogo from "assets/migrationGenW/js-yellow.svg";

const pluginLogos: Record<string, string> = {
  "Amazon SES": AmazonSESLogo,
  "PostgreSQL": PostgreSQLLogo,
  "MySQL": MySQLLogo,
  "Anthropic": AnthropicLogo,
  "Appsmith AI": AppsmithAILogo,
  "ArangoDB": ArangoDBLogo,
  "DynamoDB": AWSDynamoDBLogo,
  "AWS Lambda": AWSLambdaLogo,
  "Redshift": AWSRedshiftLogo,
  "S3": AWSS3Logo,
  "Databricks": DatabricksLogo,
  "Elastic": ElasticLogo,
  "Firestore": FirestoreLogo,
  "Google AI": GoogleAILogo,
  "Google Sheets": GooglesheetsLogo,
  "MongoDB": MongoDBLogo,
  "Microsoft SQL Server": MSSQLLogo,
  "Open AI": OpenAILogo,
  "Oracle": OracleLogo,
  "Redis": RedisLogo,
  "SMTP": SMTPLogo,
  "Snowflake": SnowflakeLogo,
  "Airtable": AirtableLogo,
  "GraphQL": GraphQLLogo,
  "REST API": RestAPILogo,
  "HubSpot": HubSpotLogo,
  "Twilio": TwilioLogo,
  "Authenticated GraphQL API":GraphQLLogo,
  "JS Functions":JSFunctionsLogo,
};

export default pluginLogos;
